import 'amazon-connect-streams';
export const ccpInit = (props) => {
    return new Promise((resolve, reject) => {
        connect.core.initCCP(props.htmlDivElement, {
            ccpUrl: props.ccpUrl,
            loginUrl: props.loginUrl,
            loginPopup: true,
            softphone: {
                // optional, defaults below apply if not provided
                allowFramedSoftphone: true, // optional, defaults to false
                allowFramedVideoCall: true, // optional, default to false
                allowFramedScreenSharing: true, // optional, default to false
                allowFramedScreenSharingPopUp: true // optional, default to false
            },
            loginOptions: {
                autoClose: true,
                height: 500,
                width: 500,
                top: 0,
                left: 0
            }
        });
        connect.core.onInitialized(() => {
            resolve();
        });
        connect.core.onIframeRetriesExhausted(() => {
            reject(new Error('Failed to connect to amazon connect. Max retries reached'));
        });
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvdmlkZXIuc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FtYXpvbkNvbm5lY3RDY3BQcm92aWRlci9Qcm92aWRlci5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sd0JBQXdCLENBQUM7QUFRaEMsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHLENBQUMsS0FBYyxFQUFpQixFQUFFO0lBQ3ZELE9BQU8sSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7UUFDckMsT0FBTyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWMsRUFBRTtZQUN6QyxNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU07WUFDcEIsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRO1lBQ3hCLFVBQVUsRUFBRSxJQUFJO1lBQ2hCLFNBQVMsRUFBRTtnQkFDVCxpREFBaUQ7Z0JBQ2pELG9CQUFvQixFQUFFLElBQUksRUFBRSw4QkFBOEI7Z0JBQzFELG9CQUFvQixFQUFFLElBQUksRUFBRSw2QkFBNkI7Z0JBQ3pELHdCQUF3QixFQUFFLElBQUksRUFBRSw2QkFBNkI7Z0JBQzdELDZCQUE2QixFQUFFLElBQUksQ0FBQyw2QkFBNkI7YUFDbEU7WUFDRCxZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFLElBQUk7Z0JBQ2YsTUFBTSxFQUFFLEdBQUc7Z0JBQ1gsS0FBSyxFQUFFLEdBQUc7Z0JBQ1YsR0FBRyxFQUFFLENBQUM7Z0JBQ04sSUFBSSxFQUFFLENBQUM7YUFDUjtTQUNGLENBQUMsQ0FBQztRQUVILE9BQU8sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRTtZQUM5QixPQUFPLEVBQUUsQ0FBQztRQUNaLENBQUMsQ0FBQyxDQUFDO1FBRUgsT0FBTyxDQUFDLElBQUksQ0FBQyx3QkFBd0IsQ0FBQyxHQUFHLEVBQUU7WUFDekMsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLDBEQUEwRCxDQUFDLENBQUMsQ0FBQztRQUNoRixDQUFDLENBQUMsQ0FBQztJQUNMLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDIn0=